import { wordService } from "../services/wordService";

export const applyAbstract = () => wordService.insertLabeledSemanticBlock("abstract");
